import { CandidateFilter } from '@pages/candidates/classes/CandidateFilter';
import { CandidateDetail } from '@pages/candidates/classes/CandidateDetail';
import { HistoryMessage } from '@shared/modules/history-message/classes/HistoryMessage';
import { CandidatePositionMinimal } from '@pages/candidates/classes/CandidatePositionMinimal';

export interface CandidateState {
  candidateFilters: CandidateFilter;
  firstLetters: string[];
  candidateDetail: CandidateDetail;
  candidateAge: number;
  historyMessages: HistoryMessage[];
  allMessageCount: number;
  currentHistoryPage: number;
  isDetailLoaded: boolean;
  loadingPositionUpdateId: number;
  currentlyEditedPositionId: number;
  isCandidatePositionsLoadingForDocumentUpload: boolean;
  isCandidatePositionsLoadedForDocumentUpload: boolean;
  candidatePositionsForDocumentUpload: CandidatePositionMinimal[];
}

export const candidateInitialState: CandidateState = {
  candidateFilters: {
    cv_content: '',
    name: '',
    email: '',
    phone: '',
    is_adult: undefined,
    is_member: undefined,
    membership_start_date: undefined,
    membership_end_date: undefined,
    lung_filter_end_date: undefined,
    medical_certificate_end_date: undefined,
    address_id: [],
    city_preference_id: [],
    user_job_preference_id: [],
    job_type_preference_id: [],
    city_id: [],
    education_type_id: [],
    requires_accommodation: undefined,
    is_shift_able: undefined,
    curriculum_vitae: undefined,
    feor_number: '',
    sumIcon: [],
    is_pensioner: undefined,
    status_id: [],
    partner_id: [],
    project_id: [],
    position_id: [],
    work_experience_id: [],
    skill_id: [],
    language_id: [],
    language_level_id: [],
    user_position_status: undefined,
    shift_id: [],
    letter_filter: '',
    sortBy: [],
    city_distance: undefined,
  },
  firstLetters: [],
  candidateDetail: undefined,
  candidateAge: -1,
  historyMessages: [],
  allMessageCount: 0,
  currentHistoryPage: 1,
  isDetailLoaded: false,
  loadingPositionUpdateId: 0,
  currentlyEditedPositionId: 0,
  isCandidatePositionsLoadingForDocumentUpload: false,
  isCandidatePositionsLoadedForDocumentUpload: false,
  candidatePositionsForDocumentUpload: [],
};
